function devDebug(...vals) {
  if (import.meta.env.VITE_DEBUG === "1") {
    for (let val of vals) {
      console.log(val);
    }
  }
}
export default devDebug;
